module.exports = __webpack_public_path__ + "static/parc_en-8e54c48eb5b8065088032cbdb810de14.jpg";